module.exports = __webpack_public_path__ + "img/ods_ES_AR.3a493507.png";